import { ecorEnv } from '@/../environments/environment';
import { HttpClient, HttpErrorResponse, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

@Injectable()
export class CaseDetailService {

    constructor(private httpClient: HttpClient) { }

    getCaseDetails(caseID: string, email: string): Observable<any> {
        const profilesUrl = ecorEnv.apiEndpoint + '/secure/pega/cases/' + caseID + '/details';
        const params = new HttpParams()
            .set('email', email);

        return this.httpClient.get<any>(profilesUrl, { params: params })
            .pipe(
                catchError(this.handleError)
            );
    }

    private handleError(error: HttpErrorResponse) {
        console.error('surveys', 'error', error);
        if (error.error instanceof ErrorEvent) {
            console.error('surveys', 'client side error:', error.error.message);
        } else {
            return throwError('Error-111111');
        }
        return throwError('Error-222222');
    }
}
